import { useEffect, useState, useRef, useMemo } from 'react';
import { motion } from 'framer-motion';
import './loader.css';

const translations = [
  "Hey, Swalih here",            // always first — brand before the flourish
  "مرحباً، صالح هنا",
  "नमस्ते, मैं स्वालिह हूँ",
  "嘿，斯瓦利赫在这里",
  "Salut, ici Swalih",
  "Hola, aquí Swalih",
  "Привет, это Свалих",
  "Swalih burada",
  "ہیلو، صالح یہاں ہے",
  "こんにちは、スワリフです",
  "Ciao Salih qui"
];

const DURATION = 3300;   // intro length — 3 greetings at GREET_MS
const GREET_MS = 1100;   // long enough to actually read each one

export default function Loader({ onDone }) {
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const done = useRef(false);

  // Only ~3 greetings fit in the intro, so shuffle the rest — English stays
  // first, and repeat visits show a different pair after it.
  const greetings = useMemo(() => {
    const [first, ...rest] = translations;
    for (let i = rest.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [rest[i], rest[j]] = [rest[j], rest[i]];
    }
    return [first, ...rest];
  }, []);

  useEffect(() => {
    const t = setInterval(() => setIndex((p) => (p + 1) % greetings.length), GREET_MS);
    return () => clearInterval(t);
  }, [greetings.length]);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(100, ((now - start) / DURATION) * 100);
      setProgress(p);
      if (p < 100) {
        raf = requestAnimationFrame(tick);
      } else if (!done.current) {
        done.current = true;
        onDone?.();
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <motion.div
      className="loaderWrapper"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1.15, ease: [0.4, 0, 0.2, 1] }}
    >
      <motion.div
        className="loaderContent"
        exit={{ opacity: 0, y: -24 }}
        transition={{ duration: 0.35, ease: "easeIn" }}
      >
        <p key={index} className="loaderText" dir="auto">{greetings[index]}</p>

        <div className="loaderMeta">
          <div className="progressBarWrapper">
            <div className="progressBar" style={{ width: `${progress}%` }} />
          </div>
          <span className="loaderPct">{String(Math.round(progress)).padStart(2, "0")}</span>
        </div>
      </motion.div>
    </motion.div>
  );
}
